// src/schemas/teamSchema.js

export const teamBreadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://cfobridge.ae/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Our Experts",
      "item": "https://cfobridge.ae/team"
    }
  ]
};

export const teamFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What professional qualifications and industry experience do the CFO Partners at CFO Bridge UAE hold?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our CFO Partners hold top-tier professional qualifications including CA (Chartered Accountant), CPA, CFA, and MBA credentials from premier institutions. They bring an average of 20+ years of industry experience spanning sectors such as technology, manufacturing, healthcare, FMCG, real estate, and financial services across India, the UAE, and the MENA region."
      }
    },
    {
      "@type": "Question",
      "name": "Will a dedicated, senior CFO Partner personally manage our account, or is the work outsourced to junior staff?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Every client engagement at CFO Bridge UAE is personally led by a senior CFO Partner. We do not delegate client-facing strategic work to junior staff. Your assigned CFO Partner is directly accountable for deliverables, financial decisions, and the overall quality of the engagement from day one."
      }
    },
    {
      "@type": "Question",
      "name": "Does your strategic CFO team have specific experience navigating the corporate regulatory framework of Dubai and the wider UAE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Our CFO Partners have direct experience navigating the UAE's regulatory environment, including Corporate Tax compliance, VAT under the Federal Tax Authority (FTA), free zone and mainland company structures, AML requirements, and DIFC/ADGM regulatory frameworks. This ensures our financial strategy advice is always grounded in UAE-specific legal and regulatory realities."
      }
    },
    {
      "@type": "Question",
      "name": "Can your financial leadership team scale operations if our business expands into Saudi Arabia or other MENA markets?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our fractional CFO model is inherently scalable. If your business expands into Saudi Arabia, Bahrain, Qatar, or other MENA markets, we can extend our engagement scope accordingly. Our team has regional knowledge across the GCC and can coordinate cross-border financial structuring, regulatory compliance, and reporting to support your growth."
      }
    },
    {
      "@type": "Question",
      "name": "How do your fractional CFO partners collaborate with an enterprise's existing internal accounting team?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our fractional CFO Partners integrate with your existing accounting team by establishing clear role boundaries, shared reporting structures, and open communication protocols. Rather than replacing your internal team, our CFOs elevate their work — providing strategic direction, financial governance frameworks, and senior oversight that turns your accounting function into a true business partner."
      }
    }
  ]
};

// Helper to generate breadcrumb for individual team member pages
export const getMemberBreadcrumbSchema = (memberName, memberId) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://cfobridge.ae/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Team",
      "item": "https://cfobridge.ae/team"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": memberName,
      "item": `https://cfobridge.ae/team/${memberId}`
    }
  ]
});